import { Injectable } from '@angular/core';
import { Action, Selector, State, Store, type StateContext } from '@ngxs/store';
import { UserEntityModels } from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';

export interface AuthControlStateModel {
  user: UserEntityModels.AuthUser | null;
}

@State<AuthControlStateModel>({
  name: 'authControl',
  defaults: {
    user: null
  }
})
@Injectable()
export class AuthControlState {
  constructor(protected store: Store,
              protected apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Selectors">

  @Selector([AuthControlState])
  static currentUser$(state: AuthControlStateModel): UserEntityModels.AuthUser | null {
    return state.user;
  }

  @Selector([AuthControlState.currentUser$])
  static isAuthenticated$(user: ReturnType<typeof AuthControlState.currentUser$>): boolean {
    return !!user;
  }

  @Selector([AuthControlState.currentUser$])
  static canAccessAuthor$(user: ReturnType<typeof AuthControlState.currentUser$>): boolean {
    return UserEntityModels.canAccessAuthor(user); 
  }

  //</editor-fold>

  //<editor-fold desc="Actions">

  @Action(FlatActions.AuthControlActions.Me)
  me() {
    return this.apiControlService.sendMessage(
      new FlatActions.AuthControlActions.MeRequest()
    );
  }

  @Action(FlatActions.AuthControlActions.MeSuccess)
  meSuccess({patchState}: StateContext<AuthControlStateModel>,
            {user}: FlatActions.AuthControlActions.MeSuccess) {
    patchState({
      user
    });
  }

  @Action(FlatActions.AuthControlActions.ClearSession)
  clearSession({patchState}: StateContext<AuthControlStateModel>) {
    patchState({
      user: null
    });
  }

  //</editor-fold>
}
